import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/chalkApi";
import { ChalkCard, DarkHeader, SectionTitle } from "../../components/chalk/primitives";
import { BackButton } from "./AdminBilling";

function Stat({ k, v }) {
  return (
    <ChalkCard style={{ marginTop: 8 }} data-testid={`funnel-${k}`}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span style={{ fontSize: 13, color: "var(--chalk-muted)" }}>{k.replaceAll("_", " ")}</span>
        <b style={{ color: "var(--chalk-board)" }}>{typeof v === "object" ? JSON.stringify(v) : v}</b>
      </div>
    </ChalkCard>
  );
}

export default function AdminVoluntold() {
  const navigate = useNavigate();
  const [days, setDays] = useState(90);
  const [funnel, setFunnel] = useState(null);
  const [codes, setCodes] = useState([]);
  useEffect(() => { api.adminVoluntoldFunnel(`?days=${days}`).then(setFunnel).catch(() => setFunnel({})); }, [days]);
  useEffect(() => { api.adminKitCodes().then((d) => setCodes(d.redemptions || [])).catch(() => {}); }, []);
  const order = ["visits", "teams_created", "kit_codes_redeemed", "parents_joined_7d", "parents_joined_30d", "paid_by_option", "coaches_active_week4"];
  return (
    <>
      <DarkHeader eyebrow="Admin" title="Voluntold funnel" subtitle="/start → team → kit code → parents → paid" right={<BackButton onClick={() => navigate(-1)} />} />
      <div style={{ padding: "0 18px 24px" }} data-testid="admin-voluntold">
        <select data-testid="funnel-days" value={days} onChange={(e) => setDays(Number(e.target.value))} style={{ marginTop: 12, fontSize: 16, padding: 8 }}>
          {[7, 30, 90, 365].map((d) => <option key={d} value={d}>Last {d} days</option>)}
        </select>
        {funnel && order.map((k) => <Stat key={k} k={k} v={funnel[k] ?? 0} />)}
        <SectionTitle label="Visits by src / utm_source" />
        {funnel && Object.entries(funnel.visits_by_src_utm || {}).map(([k, v]) => <Stat key={k} k={k} v={v} />)}
        <SectionTitle label="Kit codes" />
        {codes.map((c) => (
          <ChalkCard key={c.id} style={{ marginTop: 8 }} data-testid={`kit-code-${c.id}`}>
            <div style={{ fontSize: 13 }}>{c.user_email} · <b>{c.outcome}</b></div>
            <div style={{ fontSize: 11, color: "var(--chalk-muted)" }}>{new Date(c.redeemed_at).toLocaleString()} · ref {c.id}</div>
          </ChalkCard>
        ))}
      </div>
    </>
  );
}
